module.exports = __webpack_public_path__ + "static/fast-slider-labels-2153687b18dbc258fba63761770334f8.png";